import { render, staticRenderFns } from "./CustomizeTab.vue?vue&type=template&id=71feccf9"
import script from "./CustomizeTab.vue?vue&type=script&lang=js"
export * from "./CustomizeTab.vue?vue&type=script&lang=js"
import style0 from "./CustomizeTab.vue?vue&type=style&index=0&id=71feccf9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports